import * as React from 'react';
import { VaiIcon } from '@vaisala-rockhopper/design-tokens';
import { Bem, addClass } from '../../utils/css.js';
import { SortDirection } from '../../constants.js';
import { useId } from '../../utils/hooks/useId.js';
import { Icon } from '../Icon/Icon.js';
import './TableSortLabel.scss.js';

const bem = Bem.create("vai-table-sort");
const SortingIcon = ({ direction, className }) => {
  let icon;
  switch (direction) {
    case "ASC":
      icon = /* @__PURE__ */ React.createElement(Icon, {
        className,
        name: VaiIcon.ArrowDown
      });
      break;
    case "DESC":
      icon = /* @__PURE__ */ React.createElement(Icon, {
        className,
        name: VaiIcon.ArrowUp
      });
      break;
    default:
      icon = null;
      break;
  }
  return icon;
};
const SortIndicationIcon = ({ className }) => {
  return /* @__PURE__ */ React.createElement(Icon, {
    className,
    name: VaiIcon.ArrowUpAndDown
  });
};
const TableSortLabel = (props) => {
  const { active = false, children, direction = SortDirection.ASC, hideSortIcon = false, htmlId, className, ...rest } = props;
  const id = useId(htmlId, ["table sort label"]);
  const classes = addClass(bem.block(active && "active"), className);
  return /* @__PURE__ */ React.createElement("button", {
    id: id.toString(),
    className: classes,
    ...rest
  }, /* @__PURE__ */ React.createElement("div", {
    className: bem.element("filler")()
  }, /* @__PURE__ */ React.createElement("div", {
    className: bem.element("label")()
  }, children), hideSortIcon || !active ? null : /* @__PURE__ */ React.createElement(SortingIcon, {
    className: bem.element("icon")(),
    direction
  }), hideSortIcon ? null : /* @__PURE__ */ React.createElement(SortIndicationIcon, {
    className: bem.element("indicator-icon")(!active && "unsorted")
  })));
};

export { TableSortLabel };
